import { useEffect, useState } from "react";
import { IntlProvider } from "react-intl";
import { IClientDataResponse } from "../_services/interface/client.interface";
import { loadMessages } from "../i18n/loadMessages";

interface I18nProviderProps {
  currentClient: IClientDataResponse | undefined;
  children: React.ReactNode;
}

export const I18nProvider = ({ currentClient, children }: I18nProviderProps) => {
  const [messages, setMessages] = useState<Record<string, string>>({});

  useEffect(() => {
    loadMessages(currentClient?.guid_client).then(setMessages);
  }, [currentClient?.guid_client]);

  return (
    <IntlProvider locale="pt-BR" messages={messages} defaultLocale="pt-BR">
      {children}
    </IntlProvider>
  );
};
